import { useEffect } from "react";
import { PaymentInformationType, PaymentStatusEnum, WalletStatusEnum, WalletType } from "./ConfirmPlan.index";
import { ReactComponent as Shop } from "../../../assets/images/fileManager/shop.svg";
import { get, post, responseValidator } from "../../../scripts/api";
import API from "../../../urls/api";
import { toast } from "mobin-toast";

type EwanoCardType = {
    paymentInformation: PaymentInformationType;
    setPaymentInformation: React.Dispatch<React.SetStateAction<PaymentInformationType>>;
    planId: string;
};

export default function EwanoCard({ paymentInformation, setPaymentInformation, planId }: EwanoCardType) {
    useEffect(() => {
        handleGetBalance();
    }, []);

    const handleUpdatePaymentInformation = (updates: Partial<PaymentInformationType>) => {
        setPaymentInformation((prev) => ({
            ...prev,
            ...updates
        }));
    };

    const handleGetBalance = () => {
        get((data, status) => {
            switch (status) {
                case 428:
                    handleGetContract();
                    break;
                case 200:
                    handleUpdatePaymentInformation({
                        wallet: { ...paymentInformation.wallet, status: WalletStatusEnum.ACTIVE, balance: data.balance / 10 }
                    });
                    break;
                default:
                    handleUpdatePaymentInformation({
                        wallet: { ...paymentInformation.wallet, status: WalletStatusEnum.OFF }
                    });
            }
        }, API.ewanoWallet.balance());
    };

    const handleGetContract = () => {
        get((data, status) => {
            switch (status) {
                case 412:
                    handleUpdatePaymentInformation({
                        wallet: { ...paymentInformation.wallet, status: WalletStatusEnum.INACTIVE }
                    });
                    break;
                case 412:
                    handleUpdatePaymentInformation({
                        wallet: { ...paymentInformation.wallet, status: WalletStatusEnum.OFF }
                    });
                    break;
                case 200:
                    handleGetBalance();
                    break;
                default:
                    handleUpdatePaymentInformation({
                        wallet: { ...paymentInformation.wallet, status: WalletStatusEnum.OFF }
                    });
            }
        }, API.ewanoWallet.contract());
    };

    const handleReserve = (e: any) => {
        e.stopPropagation();
        post(
            (data, status) => {
                if (responseValidator(status)) {
                    window.location.href = data.redirect_url;
                } else {
                    toast({ title: "مشکلی در انتقال به اوانو پیش آمده.", type: "error" });
                }
            },
            API.ewanoWallet.reserve(),
            { callback_url: `/drive/confirm-pay/${planId}` }
        );
    };

    const handleWalletStatusStyles = () => {
        switch (paymentInformation.wallet.status) {
            case WalletStatusEnum.ACTIVE:
                return "text-secondary-300 cursor-default hidden";
            case WalletStatusEnum.INACTIVE:
                return "text-primary-600 cursor-pointer";
            case WalletStatusEnum.OFF:
                return "text-secondary-400 cursor-default";
            default:
                return "";
        }
    };

    return (
        <div className="lg:min-w-[400px] w-full flex flex-col p-6 bg-white rounded-lg">
            <div className="flex items-center gap-3 mb-8">
                <Shop />
                <h4 className="text-base text-secondary-800 font-medium">انتخاب روش پرداخت</h4>
            </div>
            <div
                className="flex gap-2 cursor-pointer mb-10"
                onClick={() => setPaymentInformation((prev) => ({ ...prev, status: PaymentStatusEnum.NORMAL }))}
            >
                <div
                    className={`shrink-0 size-5 flex items-center justify-center rounded-full border-[1.5px] ${paymentInformation.status === PaymentStatusEnum.NORMAL ? "bg-primary-600 border-transparent" : "border-secondary-500"}`}
                >
                    {paymentInformation.status === PaymentStatusEnum.NORMAL && <div className="size-2 bg-white rounded-full" />}
                </div>
                <div>
                    <h5 className="text-sm text-secondary-800 mb-1">پرداخت اینترنتی</h5>
                    <p className="text-xs text-secondary-600">پرداخت آنلاین با تمامی کارت‌های بانکی</p>
                </div>
            </div>
            {paymentInformation.wallet.status === WalletStatusEnum.LOADING ? (
                <div className="w-full h-[24px] skeleton" />
            ) : (
                <div
                    className={`flex gap-2 ${paymentInformation.wallet.status === WalletStatusEnum.OFF ? "opacity-50 pointer-events-none" : "cursor-pointer"}`}
                    onClick={() => setPaymentInformation((prev) => ({ ...prev, status: PaymentStatusEnum.WALLET }))}
                >
                    <div
                        className={`shrink-0 size-5 flex items-center justify-center rounded-full border-[1.5px] ${paymentInformation.status === PaymentStatusEnum.WALLET ? "bg-primary-600 border-transparent" : "border-secondary-500"}`}
                    >
                        {paymentInformation.status === PaymentStatusEnum.WALLET && <div className="size-2 bg-white rounded-full" />}
                    </div>
                    <div className="flex items-start justify-between gap-2 flex-1">
                        <div>
                            <h5 className="text-sm text-secondary-800 mb-1">پرداخت با کیف پول اوانو</h5>
                            {paymentInformation.wallet.balance !== undefined && (
                                <p className="text-xs text-secondary-600 mt-1">
                                    موجودی کیف پول: {paymentInformation.wallet.balance.toLocaleString()} تومان
                                </p>
                            )}
                        </div>
                        <p onClick={handleReserve} className={`text-[15px] font-medium ${handleWalletStatusStyles()}`}>
                            فعالسازی کیف پول
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}
